function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5578,-711)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4341.5,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.261586,-6.16298e-33,2.15704e-32,0.271636,878.256,477.032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1414.54,863.001C1439.04,863.001 1458.93,882.895 1458.93,907.398C1458.93,931.902 1439.04,951.795 1414.54,951.795C1390.03,951.795 1370.14,931.902 1370.14,907.398C1370.14,882.895 1390.03,863.001 1414.54,863.001ZM1414.54,874.072C1396.26,874.072 1381.64,889.118 1381.64,907.398C1381.64,925.679 1396.26,940.724 1414.54,940.724C1432.82,940.724 1447.44,925.679 1447.44,907.398C1447.44,889.118 1432.82,874.072 1414.54,874.072Z",
    style: {
      fill: "white"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.8f409fc13667513f6692b45a8ebca842.svg";
export { ForwardRef as ReactComponent };